/* eslint-disable no-restricted-syntax */

<template>
  <form @submit.prevent="handleSubmit">
    <div
      v-for="field of fields"
      :key="field.name"
      class="form-group"
    >
      <label
        v-if="field.label"
        :for="field.name"
      >
        {{ field.label }}
      </label>
      <textarea
        v-if="field.type == 'textarea'"
        :id="field.name"
        :value="value[field.name]"
        :rows="field.rows || 4"
        :placeholder="field.placeholder"
        :maxlength="field.maxlength"
        :required="field.required"
        @input="update(field.name, $event.target.value)"
      />
      <div v-else-if="field.type == 'image'">
        <image-chooser
          :value="value[field.name]"
          :ratio="field.ratio"
          @input="update(field.name, $event)"
        />
      </div>
      <input
        v-else
        :id="field.name"
        :value="value[field.name]"
        type="text"
        :placeholder="field.placeholder"
        :required="field.required"
        @input="update(field.name, $event.target.value)"
      >
      <div
        v-if="errors[field.name] !== undefined"
        class="invalid-feedback"
      >
        {{ errors[field.name][0] }}
      </div>
    </div>

    <button
      v-if="method == 'POST'"
      type="submit"
      class="btn btn-primary"
      :disabled="submitting"
    >
      {{ submitting ? 'Posting' : 'Post' }}
    </button>
    <button
      v-else
      type="submit"
      class="btn btn-primary"
      :disabled="submitting"
    >
      {{ submitting ? 'Saving' : 'Save' }}
    </button>
    <button
      v-if="cancelable"
      class="btn btn-secondary"
      :disabled="submitting"
      @click.prevent="$emit('cancel')"
    >
      Cancel
    </button>
  </form>
</template>

<script>
import ImageChooser from './ImageChooser.vue';

function copy(a) {
  return JSON.parse(JSON.stringify(a));
}

export default {
  name: 'BootstrapForm',
  components: {
    ImageChooser,
  },
  props: {
    value: { type: Object, default: null },
    fields: { type: Array, default: () => [] },
    url: { type: String, default: '' },
    method: { type: String, default: 'POST' },
    cancelable: { type: Boolean, default: false },
  },
  data() {
    return {
      errors: {},
      submitting: false,
    };
  },
  methods: {
    update(name, value) {
      const newValue = copy(this.value);
      newValue[name] = value;
      this.$emit('input', newValue);
    },
    async handleSubmit() {
      this.errors = {};
      this.submitting = true;

      const data = {};

      Object.keys(this.value).forEach((key) => {
        const field = this.fields.find(f => f.name === key);
        if (this.value[key] && (
          !field
          || field.type !== 'image'
          || /base64/.test(this.value[key])
        )) {
          data[key] = this.value[key];
        }
      });

      const responseData = await this.api({
        url: this.url,
        method: this.method,
        json: data,
      });

      this.submitting = false;

      if (responseData.ok) {
        this.$emit('submit', responseData.body.id);
      } else if (responseData.status === 400) {
        this.errors = responseData.body;
      } else {
        this.errors = {
          non_field_errors: [
            'Unable to communicate with the server. Please check your '
            + 'connection and try again.',
          ],
        };
      }
    },
  },
};
</script>
